import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { CLASSIC_APP_ORIGIN, MARKETING_ORIGIN } from '../utils/origins';

const STORAGE_KEY = 'dualBootBannerDismissedUntil';
const DISMISS_MS = 30 * 24 * 60 * 60 * 1000;

function isDismissed() {
  if (typeof window === 'undefined') return true;
  try {
    const until = Number(window.localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(until) && until > Date.now();
  } catch {
    return false;
  }
}

export default function DualBootBanner() {
  const [hidden, setHidden] = useState(isDismissed);

  if (hidden || typeof window === 'undefined') return null;

  const host = window.location.hostname;
  const isClassicHost = host === 'app.getupgraded.ca' || host.startsWith('app.');
  const isNewHost = host === 'getupgraded.ai' || host === 'www.getupgraded.ai';
  if (!isClassicHost && !isNewHost) return null;

  const href = isClassicHost ? MARKETING_ORIGIN : CLASSIC_APP_ORIGIN;
  const label = isClassicHost ? 'Try the new app at getupgraded.ai' : 'Open the classic app';

  const dismiss = () => {
    setHidden(true);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now() + DISMISS_MS));
    } catch {
      // Ignore storage failures; the banner just stays hidden for this session.
    }
  };

  return (
    <div className="relative border-b border-gray-100 bg-white px-10 py-2 text-center">
      <a href={href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors">
        {label}
      </a>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-1 text-gray-400 hover:bg-gray-50 hover:text-gray-900 transition-colors"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
